module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/1-c77c342e1e5de274a76e27a41c3eca8e.png";